export const staffSettings = {
  Save: "Save",
  StaffSettings: "Staff settings",
  Practitioners: "Practitioners",
  Staff: "Staff",
  PractitionersDescription:
    "Add and manage other practitioners that are a part of your dispensary.",
  StaffDescription:
    "These staff can help add {{patientTermPlural}}, assign {{patientTermPlural}} to practitioners, fill out {{treatmentPlanTermPlural}} and process in-office orders on behalf of the practitioners in your dispensary.",
  LearnMore: "Learn more",
  EnableAdvancedSecurity: "Enable advanced security",
  DisableAdvancedSecurity: "Disable advanced security",
  ToggleAdvancedSecurity: "Toggle advanced security",
  AdvancedSecurityDescription:
    "Advanced security will enforce the requirement for strong passwords",
  DispensaryOwner: "Dispensary owner",
  UpdateYourProfile: "Update your profile",
  DispensaryOwnerHavePermission:
    "Dispensary owners have some permissions that can't be assigned to staff. Learn more about ",
  Permissions: "permissions",
  AddNewPractitioner: "Add new practitioner",
  EditPractitioner: "Edit practitioner",
  EmailAddress: "Email Address",
  AddPractitionerNoteGPAOn:
    "Note: Any practitioner you add will be able to see any past {{treatmentPlanTermPlural}} and create new {{treatmentPlanTermPlural}} for all {{patientTermPlural}} on this dispensary.",
  AddPractitionerNoteGPAOff:
    "Note: Practitioners in your dispensary will only be able to send and view past {{treatmentPlanTermPlural}} of their own {{patientTermPlural}} they add.",
  UpdateGPA: "Update global {{patientTerm}} access",
  ToChangeThis: "to change this.",
  SendInvite: "Send invite",
  PractitionerType: "Practitioner type",
  AddNewStaff: "Add new staff",
  Archived: "Archived",
  ShowArchivedStaff: "Show archived staff",
  ShowArchivedPractitioners: "Show archived practitioners",
  UserArchivedSuccessfully: "{{- fullName}} was archived successfully!",
  SubstitutePractitionerWillBeAssgined:
    "Patients will be assigned to {{- fullName}} within the next few minutes",
  AddNew: "Add new",
  AddStaffNote:
    "Note: Any staff you add will be able to see any past {{treatmentPlanTermPlural}} and create new {{treatmentPlanTermPlural}} for all {{patientTermPlural}} on this dispensary.",
  ClerkAdded: "An invitation has been sent to {{- clerkName }}",
  PractitionerCreated: "An invitation has been sent to {{- practitionerName}}",
  PractitionerUpdate: "{{- practitionerName}} has been updated",
  SomethingWentWrong: "Something went wrong. Please try again.",
  EditUser: "Edit {{- fullName}}",
  FormValidation: {
    Email: {
      Invalid: "Please enter a valid email",
    },
    FirstName: {
      Invalid: "First name is required",
    },
    LastName: {
      Invalid: "Last name is required",
    },
  },
  FormSuccess: {
    Clerk: "{{- fullName}} updated successfully",
  },
  ArchivingConfirmationTitle: "You are about to archive {{- fullName}}",
  BulkPatientReassignmentArchivingConfirmationTitle:
    "Archive practitioner and unassign {{patientTermPlural}}?",
  ArchivingConfirmationDescription:
    "{{- firstName}} will no longer be able to sign in to their Fullscript account. However, any {{treatmentPlanTermPlural}}, {{patientTermPlural}}, and protocols they've previously created will remain available.",
  BulkPatientReassignmentArchivingConfirmationDescription:
    "{{- fullName}} will no longer be able to sign in to their Fullscript account. However, {{treatmentPlanTermPlural}} and {{patientTermPlural}} they've previously created will remain available.",
  ArchivingClerkConfirmationDescription:
    "{{- firstName}} will no longer be able to sign in to their Fullscript account. However, you'll still have access to any {{treatmentPlanTermPlural}} and {{patientTermPlural}} they created.",
  ArchivingConfirmationSubDescription: "Are you sure you want to archive {{- firstName}}?",
  SelectingSubstitutePractitionerDescription:
    "Assign a new practitioner now, or do it later in your patient list.",
  YesArchive: "Yes, archive",
  ArchiveStaff: "Archive staff",
  ArchivePractitioner: "Archive practitioner",
  RestoreStaff: "Restore staff",
  RestorePractitioner: "Restore practitioner",
  RestoringConfirmationTitle: "You are about to restore {{- fullName}}",
  RestoringConfirmationDescription:
    "{{- firstName}} will be able to sign back in to their Fullscript account. Are you sure you want to restore {{- firstName}}?",
  YesRestore: "Yes, restore",
  UserRestoredSucessfully: "{{- fullName}} was restored successfully!",
  SelectPractitioner: "Select a practitioner (Optional)",
} as const;
